export const EdMark = ({ className = "w-28" }) => (
  <svg viewBox="0 0 128 72" fill="none" className={className} aria-hidden="true">
    <path d="M6 6h44v13H21v11h25v13H21v10h29v13H6V6Z" fill="#FAFAFA" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M58 6h26c16.6 0 30 13.4 30 30s-13.4 30-30 30H58V6Zm14 13h12c9.4 0 17 7.6 17 17s-7.6 17-17 17H72V19Z"
      fill="#FAFAFA"
    />
    <path d="M96 6h20L88 66H68L96 6Z" fill="#7C3AED" />
  </svg>
);

export const EdLogo = ({ className = "" }) => (
  <span className={`inline-flex items-center gap-3 ${className}`}>
    <EdMark className="h-6 w-auto" />
    <span className="font-display font-800 font-extrabold tracking-[0.42em] text-sm text-paper">
      LABS
    </span>
  </span>
);
